// extracted by css-extract-rspack-plugin
export default {"string-tooltip-icon":"string-tooltip-icon-zKztV_","stringTooltipIcon":"string-tooltip-icon-zKztV_"};